import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-auto-policies-detail',
  templateUrl: './auto-policies-detail.component.html',
  styleUrls: ['./auto-policies-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoPoliciesDetailComponent {

  @Input() content: string;
  @Input() removeHowTo: boolean = false;
  @Input() provider: string;

  public showHowTo: boolean = false;
  public showComments: boolean = true;

  constructor() { }

  public toggleHowTo(): void {
    this.showHowTo = !this.showHowTo;
  }

  public toggleComments(): void {
    this.showComments = !this.showComments;
  }
}
